<div data-test="container-grafico-linha-barra">
    <div class="chart-canvas-wrap" *ngIf="hasData">
        <canvas data-test="grafico-linha-barra" baseChart
            [data]="lineChartData"
            [options]="lineChartOptions"
            [plugins]="chartPlugins"
            [type]="chartType">
        </canvas>
    </div>
    <div class="chart-legend" data-test="legenda-grafico" *ngIf="legendItems.length">
        <span data-test="item-legenda-grafico" class="chart-legend-item" *ngFor="let item of legendItems; let i = index; trackBy: trackByIndex" [class.dimmed]="item.dimmed"
            [class.selected]="selectedLegendIndices.has(i)" [class.not-clickable]="!legendFocusEnabled" (click)="onLegendItemClick(i)">
            <span class="chart-legend-swatch" [style.background-color]="item.color"></span>{{ item.text }}
        </span>
    </div>
    <p data-test="mensagem-sem-dados-grafico" *ngIf="!hasData">{{ noDataLabel }}</p>
</div>
